import React from 'react';
import { DashboardStatistic } from '@/lib/enum/dashboardStatistic';

export const statisticsIconMap: Record<DashboardStatistic, React.FC> = {
  [DashboardStatistic.TOTAL_REVENUE]: () => (
    <span style={{ fontSize: 20 }} className="material-icons text-zinc-400">
      attach_money
    </span>
  ),
  [DashboardStatistic.LOTS]: () => (
    <span style={{ fontSize: 20 }} className="material-icons-outlined text-zinc-400">
      description
    </span>
  ),
  [DashboardStatistic.BIDS]: () => (
    <span style={{ fontSize: 16 }} className="material-icons-outlined text-zinc-400">
      gavel
    </span>
  ),
  [DashboardStatistic.INVOICES]: () => (
    <span className="material-icons-outlined text-zinc-400">&#xe001;</span>
  ),
}; 